class CollectionGrid extends HTMLElement {
  constructor() {
    super();

    this._selectors = {
      productGrid: '[js-products-grid]',
      gridIcon: '[js-icon-grid]',
      listIcon: '[js-icon-list]'
    }
  }

  connectedCallback() {
  	this.toggleGrid = this.querySelector(this._selectors.toggleGrid);
  	this.productGrid = this.querySelector(this._selectors.productGrid);
    this.gridIcon = this.querySelector(this._selectors.gridIcon);
  	this.listIcon = this.querySelector(this._selectors.listIcon);
  	this._initGrid();
    this._setListeners();
  }

  _setListeners() {
    this.gridIcon.addEventListener('click', this._changeToGrid);
    this.listIcon.addEventListener('click', this._changeToList);
  }

  _initGrid() {
  	// Set localStorage first time
		if (!localStorage.getItem('gridOption')) {
			localStorage.setItem("gridOption", "grid");
		}
  	// Change grid class
  	if (localStorage["gridOption"] == "list") {
  		this._changeToList();
  	} else {
  		this._changeToGrid();
  	}
  }

  _changeToList = () => {
		this.productGrid.classList.remove("grid--3-col-desktop");
		this.productGrid.classList.add("grid--1-col-desktop");
		this.productGrid.setAttribute('aria-grid', 'list');
    document.body.classList.remove('collection-grid-view')
    document.body.classList.add('collection-list-view')
    this.gridIcon.setAttribute('aria-selected', false)
    this.listIcon.setAttribute('aria-selected', true)
		localStorage.setItem("gridOption", "list");
  }

  _changeToGrid = () => {
		this.productGrid.classList.remove("grid--1-col-desktop");
		this.productGrid.classList.add("grid--3-col-desktop");
		this.productGrid.setAttribute('aria-grid', 'grid');
    document.body.classList.add('collection-grid-view')
    document.body.classList.remove('collection-list-view')
    this.gridIcon.setAttribute('aria-selected', true)
    this.listIcon.setAttribute('aria-selected', false)
		localStorage.setItem("gridOption", "grid");
  }
}

customElements.define("s-collection-grid", CollectionGrid);
